import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Select from "react-select";
import { Dropdown } from "react-bootstrap";
import { Form, FormGroup, Label, Input } from "reactstrap";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import {
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";

import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
//** Import Image */
import food1 from "./../../../../images/foods/food1.jpg";
import food2 from "./../../../../images/foods/food2.jpg";
import food4 from "./../../../../images/foods/food4.jpg";
import food9 from "./../../../../images/foods/food9.png";
import food10 from "./../../../../images/foods/food10.jpg";
import food25 from "./../../../../images/foods/food25.jpg";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Typography from "@material-ui/core/Typography";
import FoodMenuForm from "./FoodMenuForm";
import VariantItemForm from "./VariantItemForm";
import AddOnForm from "./AddOnForm";
import { Accordion } from "@mui/material";
// import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import {
  GetOutletTimingList,
  MenuList,
  saveofMenuAVL,
  saveslotmaster,
  deleteodmenuAVL,
  updateslotmaster,
  getMenuAvailalbitListApi,
  saveoutletDetails,
  getRoleMaster,
  getoutletListMaster,
  addOutletItem,
  UpdateOutletItem,
  gettstaffListMaster,
  getMenuMasterList,
  saveMainMenuName,
  updatePWDstaffDetails,
  saveSubMenuName,
  UomList,
  deletemenuitem,
  getresbasedmenumaster,
  getresbasedPopularMenumaster,
} from "../../../../apiservicescall/api";
import swalMessage from "@sweetalert/with-react";
import swal from "sweetalert";
import {
  Table,
  Badge,
  Row,
  Card,
  Col,
  Button,
  Container,
  ListGroup,
  Tab,
} from "react-bootstrap";
import { CardTitle, CardBody } from "reactstrap";
import Multiselect from "multiselect-react-dropdown";
import SelectSearch, { fuzzySearch } from "react-select-search";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { set } from "date-fns";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#00b53b",
  },
  rootExpanded: { flexGrow: 1, width: "100%" },
}));

const TMPFoodMenuManagment = (props) => {
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const listItem = ["Breakfast", "Lunch", "Dinner", "Dosas"];
  const [menuFoodItemModal, setMenuFoodItemModal] = useState(false);
  const [subMenuModal, setSubMenuModal] = useState(false);
  const [mainMenuModal, setMainMenuModal] = useState(false);
  const [foodItemTiming, setFoodItemTiming] = useState(false);
  const [errors, setErrors] = useState({
    itemName: null,
    itemPrice: null,
    itemQuantity: null,
    itemDesc: null,
    itemfamily: null,
    uom: null,
    itemType: null,
  });
  const [formIsValid, setFormIsValid] = useState(false);
  const [checkeditem, setCheckeditem] = useState(false);
  const [isView, setIsview] = useState(false);
  const [isedit, setIsedit] = useState(false);
  const [tempModalPopupValue, setTempModalPopupValue] = useState();
  const [openImagePopup, setOpenImagePopup] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState(new Set());
  const [skipped, setSkipped] = useState(new Set());
  const [category, setCategory] = useState([]);
  const [variant, setVariant] = useState([
    { label: "Size", value: "Size" },
    { label: "Quantity", value: "Quantity" },
    { label: "Rice", value: "Rice" },
  ]);

  const [typeadd, setTypeadd] = useState([
    { label: "Extras", value: "Extras" },
    { label: "Toppings", value: "Toppings" },
    { label: "Scoope", value: "Scoope" },
  ]);
  const [selected, setSelected] = useState([]);
  const [deletepopup, setDeletepopup] = useState(false);

  const [menuMasterList, setMenuMasterList] = useState([]);

  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [loginDetails, setLoginDetails] = useState(
    JSON.parse(localStorage.getItem("userDetails"))
  );

  const [outletvalue, setOutletvalue] = useState({
    label: "",
    value: "",
  });

  const [popularmenu, setPopularMenu] = useState([]);
  const [selectedPopularMenu, setSelectedPopularMenu] = useState([
    { label: "", value: "" },
  ]);

  const [menuSubmenuItems, setMenuSubmenuItems] = useState({
    status: "A",
    menuId: "",
    menuName: "",
    subMenuId: "",
    subMenuName: "",
    selectedMainmenuItem: "",
    selectedSubmenuItem: "",

    selectedMainmenuItemValue: "",
    selectedSubmenuItemValue: "",

    selectedIndividualFoodItem: "",
    selectedIndividualFoodItemName: "",

    startTime: "",
    endTime: "",
    itemDesc: "",
    itemName: "",
    itemPrice: "",
    itemQuantity: "",
    itemType: false,
    itemFoodImage: "",
    itemFoodPath: "",
    varient: "",
    itemId: "",
    status: "",
  });

  const columns = [
    { header: "Item Name", key: "itemName" },
    { header: "Item Price", key: "itemPrice" },
    { header: "Item Type", key: "itemType" },
    { header: "Item Qty", key: "itemQuantity" },
    { header: "Uom Name", key: "uomName" },
    { header: "Item Tag", key: "itemTag" },
    { header: "Item Detail", key: "itemDesc" },
  ];

  const workSheetName = "Menu List";
  const workBookName = "Menu List";
  const myInputId = "myInput";

  const workbook = new Excel.Workbook();

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  const rootClass = expanded ? classes.rootExpanded : classes.root;
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [selectedOutlet, setSelectedOutlet] = useState(
    JSON.parse(localStorage.getItem("selectedOutlet"))
  );

  const [admintomanger, setAdmintomanger] = useState(
    JSON.parse(localStorage.getItem("admintomanger"))
  );

  const [additemSubmenuMaster, setAdditemSubmenuMaster] = useState([]);
  const [timingslist, setTimingslist] = useState([]);
  const [slotmaster, setSlotmaster] = useState([]);
  const [menuAvailablityMaster, setMenuAvailablityMaster] = useState([]);
  const [togglemodal, setTogglemodal] = useState(false);

  const [
    menuAvailablityListSaveUpdateDeleteMaster,
    setMenuAvailablityListSaveUpdateDeleteMaster,
  ] = useState([
    {
      dayId: "1",
      dayName: "Monday",
      dayStatus: "true",
    },
    {
      dayId: "2",
      dayName: "Tuesday",
      dayStatus: "true",
    },
    {
      dayId: "3",
      dayName: "Wednesday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "4",
      dayName: "Thursday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "5",
      dayName: "Friday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "6",
      dayName: "Saturday",
      dayStatus: "true",
      // slotId: []
    },
    {
      dayId: "7",
      dayName: "Sunday",
      dayStatus: "true",
      // slotId: []
    },
  ]);

  const [dropdownMaster, setDropdownMaster] = useState([
    { label: "All Day", value: "1" },
    { label: "Day Slot", value: "2" },
    // { label: "Week Days Only", value: "3" },
    // { label: "Week End Only", value: "4" }
  ]);

  const [dropdownMasterDay, setDropdownMasterDay] = useState([
    { label: "Monday", value: "1" },
    { label: "Tuesday", value: "2" },
    { label: "Wednesday", value: "3" },
    { label: "Thursday", value: "4" },
    { label: "Friday", value: "5" },
    { label: "Saturday", value: "6" },
    { label: "Sunday", value: "7" },
  ]);

  const [menu, setMenu] = useState([
    { label: "Breakfast", value: "Breakfast" },
    { label: "Lunch", value: "Lunch +" },
  ]);

  const [submenu, setSubmenu] = useState([
    { label: "Dosa varieties", value: "Dosa varieties" },
    { label: "Idly varieties", value: "Idly varieties" },
  ]);
  const [tempfoodmenu, setTempfoodmenu] = useState([
    {
      itemname: "Cocount Idly",
      price: "30",
      type: "Veg",
      itemimage: "",
      itemdetail: "",
    },
    {
      itemname: "Paneer Idly",
      price: "60",
      type: "Veg",
      itemimage: "",
      itemdetail: "",
    },
    {
      itemname: "Masala Dosa",
      price: "40",
      type: "Veg",
      itemimage: "",
      itemdetail: "",
    },
    {
      itemname: "Ghee Dosa",
      price: "80",
      type: "Veg",
      itemimage: "",
      itemdetail: "",
    },
  ]);
  /* const [menulistdetails,setMenulistdetails] = useState({
    outletCode: userDetails?.compCode,
    itemId: "",
    itemName: "",
    itemPrice: "",
    itemQuantity: "",
    itemDesc: "",
    itemType: "",
    itemFoodImage:"",
    varient:[],
    status:"", 
    compCode: userDetails?.compCode,

  }); */
  const [menulistmaster, setMenulistmaster] = useState([]);
  const [menufetchitem, setMenufetchitem] = useState([
    {
      outletCode: userDetails?.outletCode,
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemDesc: "",
      itemType: "",
      itemFoodImage: "",
      itemImagePath: "",
      uomName: "",
      itemTag: "",
      /* varient:[],
    status:"", */
      compCode: userDetails?.compCode,
    },
  ]);

  const [uomlist, setUomlist] = useState([
    {
      uomId: "",
      uomDescription: "",
      status: "",
    },
  ]);
  const [uomcategory, setUomcategory] = useState([]);
  const [selecteduomMaster, setSelecteduomMaster] = useState({
    label: "",
    value: "",
  });

  const [menulistitem, setMenulistitem] = useState([
    {
      compCode: userDetails,
      itemDesc: "",
      itemFoodImage: "",
      itemImagePath: "",
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemType: true,
      itemTag: "",
      outletCode: userDetails,
      status: "",
      uom: "",
      varient: [
        {
          varientType: "",
          small: "",
          medium: "",
          large: "",
        },
      ],
      outletfoodtype: "",
    },
  ]);

  const [dropdownslotmaster, setDropdownslotmaster] = useState([]);
  const [dropdownMastervalue, setDropdownMastervalue] = useState({
    label: "",
    name: "",
  });

  const [specialmenulist, setSpecialMenu] = useState([]);

  const [outletlist, setoutletlist] = useState([]);
  const [selectedrestarant, setSelectedrestarant] = useState([
    { label: "", value: "" },
  ]);

  const [selectedspecialMenu, setSelectedSpecialMenu] = useState([
    { label: "", value: "" },
  ]);
  const [price, setPrice] = useState([]);

  const [subscribeItemModalm, setSubscribeItemModal] = useState(false);

  const admintomangerjson = admintomanger && admintomanger.split("-");
  const adminToMangerOutletName =
    admintomangerjson && admintomangerjson[0].trim();
  const adminToMangerOutletCode =
    admintomangerjson && admintomangerjson[1].trim();
  const adminToMangerCompanyCode =
    admintomangerjson && admintomangerjson[2].trim();

  useEffect(() => {
    getMenuMasterListMasterApi();
    let outletCode =
      adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    getoutlettimeList(outletCode);
    getmenulist(compCode, outletCode);
    getuomlist();
    // getRestarantmenulist();
    // getoutletList(compCode);
  }, []);

  const saveExcel = async () => {
    try {
      const myInput = document.getElementById(myInputId);
      const fileName = workBookName;

      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);

      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;

      // updated the font for first row.
      worksheet.getRow(1).font = { bold: true };

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 5;
        column.alignment = { horizontal: "center" };
      });

      // loop through data and add each one to worksheet
      menufetchitem.forEach((singleData) => {
        worksheet.addRow(singleData);
      });

      // loop through all of the rows and set the outline style.
      worksheet.eachRow({ includeEmpty: false }, (row) => {
        // store each cell to currentCell
        const currentCell = row._cells;

        // loop through currentCell to apply border only for the non-empty cell of excel
        currentCell.forEach((singleCell) => {
          // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
          const cellAddress = singleCell._address;

          // apply border
          worksheet.getCell(cellAddress).border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      });

      // write the content using writeBuffer
      const buf = await workbook.xlsx.writeBuffer();

      // download the processed file
      saveAs(new Blob([buf]), `${fileName}.xlsx`);
    } catch (error) {
      console.error("<<<ERRROR>>>", error);
      console.error("Something Went Wrong", error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };

  //list api//
  const getmenulist = async (compCode, outletCode) => {
    /*  */
    let getslotList = await MenuList(compCode, outletCode);
    let getslotListValue = getslotList?.data?.data;
    setMenufetchitem(getslotListValue);
    setMenulistmaster(getslotListValue);
    console.log("getslotListValue", getslotListValue);
    // let filteredMenuItemList  =  getslotListValue
    // &&  getslotListValue.filter((item) => item.itemDesc.substring(0,4) == searchfieldvalue.substring(0,4)).map((items) => ({ items }));
    let searchfieldvalue = "dd";
    let filteredMenuItemList =
      getslotListValue &&
      getslotListValue.filter(
        (item) =>
          item.itemDesc.substring(0, 1) == searchfieldvalue.substring(0, 1)
      );
    // .map((items) => ({ items }));
    console.log("filteredMenuItemList", filteredMenuItemList);
    // setMenufetchitem(filteredMenuItemList);
  };

  //search list filter function //
  const searchFilterMenuListMaster = async (value) => {
    //
    // console.log("value", value);
    // console.log("value", value.length);
    // console.log("value", typeof value.length);
    if (value == "") {
      // console.log("value", value);
      // console.log("value", value.length);
      // return false;
      let outletCode =
        adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
      let getslotList = await MenuList(compCode, outletCode);
      let getslotListValue = getslotList?.data?.data;
      setMenufetchitem(getslotListValue);
    } else if (value && value.length >= 1) {
      // console.log("elsevalue", value);
      // console.log("elsevaluelength", value.length);
      let outletCode =
        adminToMangerOutletCode || loginDetails?.outletResponses[0]?.outletCode;
      let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
      let getslotList = await MenuList(compCode, outletCode);
      let getslotListValue = getslotList?.data?.data;
      let valulength = value && value.length;
      // console.log("valulength", valulength);
      let filteredMenuItemList =
        getslotListValue &&
        getslotListValue.filter((item) =>
          // (item.itemTag.substring(0, valulength) ||
          // (item.itemName.substring(0, valulength)) == value.substring(0, valulength)
          item.itemName.includes(value)
            ? value
            : "" || item.itemTag.includes(value)
            ? value
            : ""
        );

      // let strinincludesfilteredMenuItemList = getslotListValue && getslotListValue.filter(
      //   (item) => (item.itemTag.includes(value)) ? value : ""
      // );
      // console.log("filteredMenuItemList", filteredMenuItemList);
      // let searchfieldvalue = "dd";
      // let filteredMenuItemList = getslotListValue && getslotListValue.filter((item) => item.itemDesc.substring(0, 1) == value.substring(0, 1))
      //   .map((items) => ({ items }));
      // console.log("filteredMenuItemList", filteredMenuItemList);
      setMenufetchitem(filteredMenuItemList);
    }
  };

  const getRestarantmenulist = async (value) => {
    let restaurantId = value;
    let getresmenuid = await getresbasedmenumaster(restaurantId);
    console.log("getresmenuid", getresmenuid);

    let getresmenu = getresmenuid.data.data || [];

    console.log("getresmenu getresmenu", getresmenu);

    let specialmenulist = getresmenu.map(({ id, name, price }) => ({
      label: `${name}-  Rs. ${price}`,
      value: `${id}-${name}-${price}`,
    }));

    setSpecialMenu(specialmenulist);
    // console.log("specialmenulist", specialmenulist);
  };

  const getoutletList = async () => {
    /*  */

    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    let getoutletList = await getoutletListMaster(compCode);
    let getoutletListValue = getoutletList?.data?.data;
    let Outcode =
      adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;

    let resturant =
      getoutletListValue &&
      getoutletListValue
        .filter((item) => item.outletCode == Outcode)
        .map((items) => ({ items }));
    let resturantId = resturant[0]?.items?.restaurantId;
    console.log("resturantId", resturantId);
    getRestarantmenulist(resturantId);
    getRestarantPopularlist(resturantId);
    let tempstatemaster =
      getoutletListValue &&
      getoutletListValue
        .filter((item) => item.outletCode == Outcode)
        .map((items) => ({ items }));
    let checkItemVegTypefromOutletChe =
      tempstatemaster[0] &&
      tempstatemaster[0]?.items?.outletFoodType == "veg,nong-veg"
        ? "veg,nong-veg"
        : "veg";
    /*  setIsview(false);
    setIsedit(false); */
    console.log(
      "tempstatemaster[0]?.items?.outletFoodType",
      tempstatemaster[0]?.items?.outletFoodType
    );

    setMenulistitem({
      itemDesc: "",
      itemFoodImage: "",
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemType: true,
      outletfoodtype: checkItemVegTypefromOutletChe,
    });

    /* setMenulistitem({
      itemDesc: "",
      itemFoodImage: "",
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemType: true,
    }); */
    getMenuMasterListMasterApi();
    setSelecteduomMaster({});
    setActiveStep(0);
    setErrors({});
    setMenuFoodItemModal(!menuFoodItemModal);
    setIsview(false);
    setIsedit(false);
    setSubscribeItemModal(false);
  };

  const getoutlettimeList = async (outletCode) => {
    let getoutletList = await GetOutletTimingList(outletCode);
    let getoutletListValue = getoutletList?.data?.data;
    setTimingslist(getoutletListValue);
    // console.log("getoutletListValue", getoutletListValue);
  };

  //master data//
  const getuomlist = async () => {
    let getuomList = await UomList();
    let getuomListValue = getuomList?.data?.data;
    let outmaster =
      getuomListValue &&
      getuomListValue.map(({ status, uomDescription, uomId }) => ({
        label: uomDescription,
        value: uomId,
      }));
    setUomlist(getuomListValue);
    setUomcategory(outmaster);
    // console.log("outmaster", outmaster);
    // console.log("getuomListValue", getuomListValue);
  };

  const getMenuMasterListMasterApi = async () => {
    menumasterlabelvalue();
    setMenuSubmenuItems({
      menuId: menuSubmenuItems?.menuId,
      menuName: menuSubmenuItems?.menuName,
      selectedSubmenuItem: menuSubmenuItems?.selectedSubmenuItem,
      selectedSubmenuItemValue: menuSubmenuItems?.selectedSubmenuItemValue,
      subMenuId: menuSubmenuItems?.subMenuId,
      selectedMainmenuItem: menuSubmenuItems?.selectedMainmenuItem,
      selectedMainmenuItemValue: menuSubmenuItems?.menuId,
    });
  };

  const menumasterlabelvalue = () => {
    let outmaster =
      menuMasterList &&
      menuMasterList.map(({ menuId, menuName }) => ({
        label: menuName,
        value: menuId,
      }));
    setCategory(outmaster);
  };

  const dropdownHandling = async (type, event) => {
    // if (event?.value == "2") {
    //   setDropdownMasterDay([])
    // }
    setDropdownMastervalue(event);
    console.log("dropdownMastervalue", dropdownMastervalue);
    // const [dropdownMastervalue, ] = useState({ label: "", name: "" });
  };

  const onToggleClose = () => {
    setTogglemodal(!togglemodal);
  };

  const itemtoggle = async (items) => {
    /*  */
    const str = [items?.itemTag];
    const result = str.toString().split(",");
    /* .filter(function (e) {
       return e;
     });; */
    setSelected(result);

    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    let getoutletList = await getoutletListMaster(compCode);
    let getoutletListValue = getoutletList?.data?.data;
    let Outcode =
      adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
    let tempstatemaster =
      getoutletListValue &&
      getoutletListValue
        .filter((item) => item.outletCode == Outcode)
        .map((items) => ({ items }));
    let checkItemVegTypefromOutletChe =
      tempstatemaster[0] &&
      tempstatemaster[0]?.items?.outletFoodType == "veg,nong-veg"
        ? "veg,nong-veg"
        : "veg";
    console.log(
      "tempstatemaster[0]?.items?.outletFoodType",
      tempstatemaster[0]?.items?.outletFoodType
    );

    setMenulistitem({
      itemDesc: items?.itemDesc,
      itemFoodImage: items?.itemFoodImage,
      itemImagePath: items?.itemImagePath,
      itemId: items?.itemId || "",
      itemName: items?.itemName,
      itemPrice: items?.itemPrice,
      itemTag: items?.itemTag,
      itemQuantity: items?.itemQuantity,
      itemType: items?.itemType === "veg" ? true : false,
      outletfoodtype: checkItemVegTypefromOutletChe,
      // outletfoodtype:
      //   items?.itemType === "veg,nong-veg" ? "veg,nong-veg" : "veg",
      outletCode:
        adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode,
      status: "A",
      uom: items?.uom,
      uomName: items?.uomName,
    });
    getuomlist();
    setSelecteduomMaster({
      label: items?.uomName,
      value: items?.uom,
    });

    setMenuFoodItemModal(true);
    setIsview(true);
    setIsedit(false);
    setFormIsValid(false);
    setErrors({});
  };

  const deletetoggle = (items) => {
    /*  */
    setMenulistitem({
      itemDesc: items?.itemDesc,
      itemFoodImage: "",
      itemImagePath: items?.itemImagePath,
      uom: items?.uom,
      itemId: items?.itemId || "",
      itemName: items?.itemName,
      itemPrice: items?.itemPrice,
      itemQuantity: items?.itemQuantity,
      menuName: items?.mainMenuName,
      categoryName: items?.categoryName,
      subCategoryName: items?.subCategoryName,
      categoryId: items?.categoryId,
      subCategoryId: items?.subCategoryId,

      itemType: items?.itemType === "veg" ? true : false,
      outletCode:
        adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode,
      status: "A",
    });

    setDeletepopup(true);
    setIsview(true);
    setIsedit(false);
    setFormIsValid(false);
    /*  setErrors({}); */
  };

  const nestedLevelItemCheck = async (dayId, slotData) => {
    await setMenuAvailablityListSaveUpdateDeleteMaster(
      menuAvailablityListSaveUpdateDeleteMaster.map((items) => ({
        ...items,
        slotId: items.slotId.map((object1) =>
          items.dayId == dayId && object1.slotId == slotData?.slotId
            ? { ...object1, itemAvailablity: !slotData?.itemAvailablity }
            : object1
        ),
      }))
    );
  };

  const apiMasterCallOfmenuAvailablityListSaveUpdateDeleteMaster = async () => {
    // console.log("current", menuAvailablityListSaveUpdateDeleteMaster);
    // console.log("current", menuSubmenuItems);

    // setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
    //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   }),
    // );

    // let saveupdateMasterOFmenuAvailablityListSaveUpdateDeleteMaster =
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.filter((item) => item.itemAvailablity === true)
    //       .map((item) => {
    //         return item["slotId"];
    //       })
    //   }));

    // let filtetredsave =
    //   saveupdateMasterOFmenuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   });

    // let deleteMasterOFmenuAvailablityListSaveUpdateDeleteMaster =
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.filter((item) => item.itemAvailablity === false)
    //       .map((item) => {
    //         return item["slotId"];
    //       })
    //   }));

    // let filtetredupdate =
    //   deleteMasterOFmenuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["mainMenuId"] = menuSubmenuItems?.mainMenuId;
    //     obj["subMenuId"] = menuSubmenuItems?.subMenuId;
    //     obj["menuId"] = menuSubmenuItems?.selectedIndividualFoodItem;
    //     return { ...obj };
    //   });

    // let savereqformenusubmenu = await saveofMenuAVL(filtetredsave);
    // let deletereqformenusubmenu = await deleteodmenuAVL(filtetredupdate);

    // console.log("finalupdate0001", menuAvailablityListSaveUpdateDeleteMaster);
    // console.log("finalupdate0002", filtetredsave);
    // console.log("finalupdate0003", filtetredupdate);

    swal("Success!", "Time Slots Updated", "success");
    setFoodItemTiming(!foodItemTiming);
  };

  const saveMenuSubmenu = async (key) => {
    let data = "";
    data = {
      outletCode:
        adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode,
      status: "A",
      menuId: outletvalue?.value || "",
      menuName: menuSubmenuItems?.menuName || "",
      subMenuId: menuSubmenuItems?.subMenuId || "",
      subMenuName: menuSubmenuItems?.subMenuName || "",
    };
    let reqformenusubmenu;
    if (key === "Maninmenu") {
      reqformenusubmenu = await saveMainMenuName(data);
    } else if (key === "SubManinmenu") {
      reqformenusubmenu = await saveSubMenuName(data);
    } else {
    }

    if (reqformenusubmenu.data.status === true) {
      setMenuSubmenuItems({});
      setMainMenuModal(false);
      setSubMenuModal(false);
      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      getMenuMasterListMasterApi();
      setIsview(false);
      setIsedit(false);
      if (key === "Maninmenu") {
        swal("Success!", "Menu Created", "success");
      } else {
        swal("Success!", "Sub Menu Updated", "success");
      }
    } else {
      setMainMenuModal(!mainMenuModal);
      getMenuMasterListMasterApi();
      swal("Oops", "Error, Please Try Later", "error");
    }
  };

  const onChangeCommonpopup = (key, value) => {
    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    if (key == "itemType") {
      //
      // console.log("key", key)
      // console.log("key", value)
      addFieldValue = { [key]: value };
      setFormIsValid(formIsValidLocal);
    }

    if (key == "itemFoodImage") {
      const newFormData = { ...menulistitem };
      newFormData[key] = value.target.files[0];
      setMenulistitem(newFormData);
    } else {
      const newFormData = { ...menulistitem };
      newFormData[key] = value;
      setMenulistitem(newFormData);
    }
  };

  const blockInvalidChar = (e) => {
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  };

  const onChangeCommonpopupsetOutletvalue = (key, value) => {
    console.log("key", key);
    console.log("value", value);

    let addFieldValue = {};
    let errorsLocal = errors;
    let formIsValidLocal = formIsValid;

    const stringPattern = /^[-a-zA-Z-()]+(\s+[-a-zA-Z()]+)*$/;
    const stringwithnumberPattern = /^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/;
    const mobilePattern = /^[5-9][0-9]{9}$/;
    const emailPattern =
      /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([\.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;

    if (key == "itemName") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemName"] = "Item Name is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
      // else if (!stringwithnumberPattern.test(value)) {
      //   addFieldValue = { [key]: null };
      //   errorsLocal["itemName"] = "Invalid";
      //   setErrors(errorsLocal);
      //   formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
      //   setFormIsValid(formIsValidLocal);
      // }
      else {
        // console.log("value", value);

        let values = value.value.split("-");
        // console.log("values", values);

        let id = values[0];
        let name = values[1];
        let price = values[2];

        console.log("name", name);
        console.log("price", price);

        setMenulistitem({
          itemName: name,
          itemPrice: price,
        });
        console.log("menulistitem", menulistitem);
        // console.log("price", price);
        addFieldValue = { [key]: name, itemPrice: price };
        errorsLocal["itemName"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    // if (key == "itemPrice") {
    //   if (!value) {
    //     addFieldValue = { [key]: null };
    //     errorsLocal["itemPrice"] = "Item Price is Required";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   } else if (!stringwithnumberPattern.test(value)) {
    //     addFieldValue = { [key]: null };
    //     errorsLocal["itemPrice"] = "Invalid";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   } else {
    //     addFieldValue = { [key]: value };
    //     errorsLocal["itemPrice"] = "";
    //     setErrors(errorsLocal);
    //     formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
    //     setFormIsValid(formIsValidLocal);
    //   }
    // }

    if (key == "itemQuantity") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemQuantity"] = "Item Quanity is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else if (!stringwithnumberPattern.test(value)) {
        addFieldValue = { [key]: null };
        errorsLocal["itemQuantity"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["itemQuantity"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemDesc") {
      if (!value) {
        addFieldValue = { [key]: null };
        errorsLocal["itemDesc"] = "Item Desc is Required";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        addFieldValue = { [key]: value };
        errorsLocal["itemDesc"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "itemTag") {
      // console.log("value.length", value.length);
      console.log("value.length", value[0]);
      console.log("value.length", selected);
      // let trimmedvalue = value && value[0].trim();

      if (value[0] == "") {
        return false;
      } else {
        // const arr = [" zero ", " one ", " two "];
        const trimmedItemTagArray = value && value.map((item) => item.trim());
        console.log("trimmedItemTagArray", trimmedItemTagArray);
        let duplicateItemTagArray = [...new Set(trimmedItemTagArray)];
        console.log("duplicateItemTagArray", duplicateItemTagArray);
        const tempstatemaster =
          duplicateItemTagArray &&
          duplicateItemTagArray
            .filter((item) => item != "")
            .map((item) => {
              return item && item.toLowerCase();
            });

        console.log("tempstatemaster", tempstatemaster);
        setSelected(tempstatemaster || []);

        addFieldValue = { [key]: value };
        errorsLocal["itemTag"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    if (key == "uom") {
      if (!value) {
        addFieldValue = { [value.label]: null };
        errorsLocal["uom"] = "Invalid";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      } else {
        setSelecteduomMaster({
          label: value.label,
          value: value.value,
        });
        // addFieldValue = { ["role"]: value.value }
        errorsLocal["uom"] = "";
        setErrors(errorsLocal);
        formIsValidLocal = Object.values(errorsLocal).every((o) => o == "");
        setFormIsValid(formIsValidLocal);
      }
    }

    const newFormData = { ...menulistitem };
    newFormData[key] = value;
    setMenulistitem(newFormData);
  };

  /* const onChangeCommonpopupsetOutletvalue = (key, event) => {
     
     console.log("event", event);
     setAdditemSubmenuMaster([]);
    if (key == "mainmenuname") {
      setMenufetchitem({
        menuId: event.value,
        menuName: event.label,
        selectedMainmenuItem: event,
      });
      const tempstatemaster = menuMasterList
        .filter((item) => item.menuId == event.value)
        .map((item) => {
          return item.subMenu;
        });

      let additemSubmenuMasterresponse = tempstatemaster[0]?.map(
        ({ subMenuName, subMenuId }) => ({
          label: subMenuName,
          value: subMenuId,
        })
      );

      console.log("additemSubmenuMasterresponse", additemSubmenuMasterresponse);
      setAdditemSubmenuMaster(additemSubmenuMasterresponse);
    }

    if (key == "submainmenuname") {
       
       console.log("menuSubmenuItems?.menuId", menuSubmenuItems);

      setMenufetchitem({
        selectedSubmenuItem: event.label,
        subMenuId: event.value,
        subMenuName: event.label,

        menuId: menuSubmenuItems?.menuId,
        menuName: menuSubmenuItems?.menuName,
         menuName: event.label,
         selectedMainmenuItem: event
      });

      const tempstatemaster = menuMasterList
        .filter((item) => item.menuId == menuSubmenuItems?.menuId)
        .map((item) => {
          return item?.subMenu[0].subMenuItem;
        });

      console.log("tempstatemaster", tempstatemaster);

       let additemSubmenuMasterresponse = tempstatemaster && tempstatemaster.length > 0 && tempstatemaster?.map(({ itemName, itemId }) => ({
         label: itemName,
         value: itemId,
       }));
       console.log("additemSubmenuMasterresponse", additemSubmenuMasterresponse);
    }
  }; */

  /* function getSteps() {
    // return ["Add Item Details", "Variant Item & Add-Ons"];
    return ["Add Item Details"];
  } */

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <FoodMenuForm
            menulistitem={menulistitem}
            additemSubmenuMaster={additemSubmenuMaster}
            onChangeCommonpopup={onChangeCommonpopup}
            category={category}
            uomlist={uomlist}
            selecteduomMaster={selecteduomMaster}
            uomcategory={uomcategory}
            errors={errors}
            isView={isView}
            onChangeCommonpopupsetOutletvalue={
              onChangeCommonpopupsetOutletvalue
            }
            blockInvalidChar={blockInvalidChar}
          />
        );

      case 1:
        return <VariantItemForm variant={variant} />;
    }
  }

  const chkImgFile = (file) => {
    // console.log("file", file);
    if (file) {
      const fileArr = file.split(".");
      const fileExt = fileArr[fileArr.length - 1];
      if (fileExt.toLowerCase() == "pdf") {
        return false;
      } else {
        return true;
      }
    }
  };
  const skippedSteps = () => {
    return skipped.size;
  };
  const isStepOptional = (step) => {
    return step === 1 || step === 2;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleStep = (step) => {
    console.log("step", step);
    setActiveStep(step);
  };
  /*  const totalSteps = () => {
    return getSteps().length;
  }; */
  const completedSteps = () => {
    return completed.size;
  };

  /* const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps() - skippedSteps();
  }; */

  const getRestarantPopularlist = async (e) => {
    let restaurantId = e;

    let getresmenuid = await getresbasedPopularMenumaster(restaurantId);
    //console.log("getresmenuid", getresmenuid);

    let getresmenu = getresmenuid.data.data || [];

    //console.log("getresmenu getresmenu", getresmenu);

    let specialmenulist = getresmenu.map(({ id, name, price }) => ({
      label: name,
      value: `${id}- ${name}-${price} `,
    }));
    setPopularMenu(specialmenulist);
  };

  const getSubscriptionList = async () => {
    let compCode = adminToMangerCompanyCode || loginDetails?.companyCode;
    let getoutletList = await getoutletListMaster(compCode);
    let getoutletListValue = getoutletList?.data?.data;
    // console.log("getoutletListValue78889", getoutletListValue);
    let Outcode =
      adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
    let tempstatemaster =
      getoutletListValue &&
      getoutletListValue
        .filter((item) => item.outletCode == Outcode)
        .map((items) => ({ items }));
    let checkItemVegTypefromOutletChe =
      tempstatemaster[0] &&
      tempstatemaster[0]?.items?.outletFoodType == "veg,nong-veg"
        ? "veg,nong-veg"
        : "veg";

    setMenulistitem({
      itemDesc: "",
      itemFoodImage: "",
      itemId: "",
      itemName: "",
      itemPrice: "",
      itemQuantity: "",
      itemType: true,
      planId: "",
      planName: "",
      outletfoodtype: checkItemVegTypefromOutletChe,
    });

    getMenuMasterListMasterApi();
    setSelecteduomMaster({});
    setActiveStep(0);
    setErrors({});
    setMenuFoodItemModal(!menuFoodItemModal);
    setSubscribeItemModal(true);
    setIsview(false);
    setIsedit(false);
    // console.log("menuFoodItemModal", menuFoodItemModal);
  };

  const submitFoodItemApi = async () => {
    console.log("selected", selected);
    console.log("menulistitem.itemTag", menulistitem.itemTag);

    let values = selectedspecialMenu.value.split("-");
    let id = values[0];
    let name = values[1];
    let price = values[2];
    console.log("valuesdata", values);

    console.log("priceprice", price);

    let data = "";
    data = {
      compCode: adminToMangerCompanyCode || userDetails?.companyCode,
      itemDesc: menulistitem?.itemDesc,
      itemFoodImage: menulistitem?.itemFoodImage || "",
      itemId: id.toString() || "",
      itemName: name,
      itemPrice: price,
      itemTag: selected && selected.toString(),
      itemQuantity: "1",
      itemType: menulistitem?.itemType === true ? "veg" : "nonveg",
      outletCode:
        adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode,
      status: "A",
      uom: selecteduomMaster?.value,
      itemImagePath:
        menulistitem?.itemFoodImage == undefined
          ? menulistitem?.itemImagePath
          : "",
      // itemImagePath: menulistitem?.itemImagePath,
      varient: [
        // { large: "", medium: "",small: "",  varientId:"", varientType:  ""}
      ],
    };
    console.log("data", data);

    //  return false
    let formData = new FormData();

    for (var key in data) {
      if (Array.isArray(data[key])) {
        data[key].forEach((obj, index) => {
          let keyName = [key, "[", index, "]"].join("");
          formData.append("itemFoodImage", obj);
        });
      } else {
        var f = new File([""], "filename");
        if (key == "itemFoodImage" && data["itemFoodImage"] == "") {
          formData.append(key, f);
        } else {
          formData.append(key, data[key]);
        }
      }
    }
    /*   console.log("data", data);
      console.log("formData", formData); */
    /* return false; */

    let reqformenusubmenu;
    if (menulistitem?.itemId == undefined || menulistitem?.itemId == "") {
      reqformenusubmenu = await addOutletItem(formData);
    } else {
      reqformenusubmenu = await UpdateOutletItem(formData);
    }

    if (reqformenusubmenu.data.status === true) {
      if (menulistitem?.itemId == undefined || menulistitem?.itemId == "") {
        swal("Success!", "Item Added", "success");
      } else {
        swal("Success!", "Item Updated", "success");
      }
      setMenulistitem({});
      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      getmenulist(
        adminToMangerCompanyCode || userDetails?.companyCode,
        adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode
      );
      setMainMenuModal(false);
      setSubMenuModal(false);
      setMenuFoodItemModal(!menuFoodItemModal);
      setIsview(false);
      setIsedit(false);
    } else {
      swal("Oops", "Error, Please Try Later", "error");
      setMenuFoodItemModal(false);
      setFoodItemTiming(false);
      getmenulist(
        adminToMangerCompanyCode || userDetails?.companyCode,
        adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode
      );
      setMainMenuModal(false);
      setSubMenuModal(false);
      setMenuFoodItemModal(!menuFoodItemModal);
      setIsview(false);
      setIsedit(false);
      setMenulistitem({});
    }
  };

  const getMenuAvailalbitList = async () => {
    // console.log("menuSubmenuItems", menuSubmenuItems?.selectedMainmenuItem?.value)
    let outletCode =
      adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
    let mainMenuId = menuSubmenuItems?.menuId;
    let subMenuId = menuSubmenuItems?.subMenuId;
    let menuId = menuSubmenuItems?.selectedIndividualFoodItem;
    let menuavailityList = await getMenuAvailalbitListApi(
      outletCode,
      mainMenuId,
      subMenuId,
      menuId
    );
    await setMenuAvailablityMaster(menuavailityList.data?.data);
    await setMenuSubmenuItems({
      mainMenuId: menuSubmenuItems?.menuId,
      subMenuId: menuSubmenuItems?.subMenuId,
      selectedIndividualFoodItem: menuSubmenuItems?.selectedIndividualFoodItem,
      selectedIndividualFoodItemName:
        menuSubmenuItems?.selectedIndividualFoodItemName,
    });
    // setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
    //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
    //     obj["slotId"] = enablebollean;
    //     return { ...obj };
    //   }),
    // );
    console.log(
      "menuAvailablityListSaveUpdateDeleteMaster",
      menuAvailablityListSaveUpdateDeleteMaster
    );
    // console.log("menuavailityList", menuavailityList.data?.data);
    console.log("length", menuavailityList.data?.status);

    if (menuavailityList.data?.status === true) {
      setMenuAvailablityListSaveUpdateDeleteMaster(menuavailityList.data?.data);

      // await setMenuAvailablityListSaveUpdateDeleteMaster(menuAvailablityListSaveUpdateDeleteMaster =>
      //   menuAvailablityListSaveUpdateDeleteMaster.map(obj => {
      //     obj["slotId"] = menuavailityList.data?.data;
      //     return { ...obj };
      //   }),
      // );

      // await setMenuAvailablityListSaveUpdateDeleteMaster(
      //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
      //     ...items,
      //     slotId: items.slotId && items.slotId.filter(object1 => {
      //       return menuavailityList.data?.data.map(object2 => ({
      //         ...object2,
      //         slotTime: object2.slotTime.some(object3 => {
      //           object1["itemAvailablity"] = true;
      //           object1["itemAvailablity"] = false;
      //           return parseInt(object1.slotId) === parseInt(object3.slotId) ?
      //             { ...object1["itemAvailablity"] = true }
      //             :
      //             { ...object1["itemAvailablity"] = false }
      //         })
      //       }
      //       ));
      //     })
      //   })));
    } else {
      // setMenuAvailablityListSaveUpdateDeleteMaster(
      //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
      //     ...items,
      //     slotId: items.slotId.map(object1 => {
      //       return { ...object1, itemAvailablity: true }
      //     })
      //   })));

      await setMenuAvailablityListSaveUpdateDeleteMaster(
        (menuAvailablityListSaveUpdateDeleteMaster) =>
          menuAvailablityListSaveUpdateDeleteMaster.map((obj) => {
            obj["slotId"] = [];
            return { ...obj };
          })
      );
    }

    // setMenuAvailablityListSaveUpdateDeleteMaster(
    //   menuAvailablityListSaveUpdateDeleteMaster.map(items => ({
    //     ...items,
    //     slotId: items.slotId.map((itemss) => {
    //       return itemss.slotId
    //     })
    //       == menuavailityList.data?.data?.map((items2) => {
    //         return items2.slotId
    //       }) ?
    //       // obj["slotId"] = enablebollean;
    //       // return { ...obj };
    //       { ...itemss, itemAvailablity: true }
    //       :
    //       { ...itemss, itemAvailablity: false }
    //   }))
    // );

    console.log(
      "setMenuAvailablityListSaveUpdateDeleteMaster456",
      menuAvailablityListSaveUpdateDeleteMaster
    );
    await setFoodItemTiming(true);
    console.log("vijay", menuSubmenuItems);
  };

  const deleteitem = async (key) => {
    /*  */
    console.log("key", key);
    let compCode = adminToMangerCompanyCode || userDetails?.companyCode;
    let outletCode =
      adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode;
    let menuId = menulistitem.itemId || "";

    let reqformenusubmenu;
    if (key === "Deletemenu") {
      reqformenusubmenu = await deletemenuitem(compCode, outletCode, menuId);
    } else {
    }

    if (reqformenusubmenu.data.status === true) {
      setMenulistitem({});
      setDeletepopup(false);

      getmenulist(
        userDetails?.companyCode,
        adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode
      );
      setIsview(false);
      setIsedit(false);

      if (key === "Deletemenu") {
        swal("Success!", "Menu Item Deleted", "success");
      } /* else {
        swal("Success!", "Sub Menu Created", "success");
      } */
    } else {
      getmenulist(
        userDetails?.companyCode,
        adminToMangerOutletCode || userDetails?.outletResponses[0]?.outletCode
      );
      setDeletepopup(false);

      swal("Oops", `${reqformenusubmenu.data.message}`, "error");
    }
  };

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  const onClose = () => {
    setMainMenuModal(!mainMenuModal);
  };

  const CloseImage = () => {
    setOpenImagePopup(!openImagePopup);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const renderItem = ({ item, collapseIcon, handler }) => {
    return (
      <div>
        {handler}
        {collapseIcon}
        {item.mainmenu}
      </div>
    );
  };

  const stylescheck = () => {
    let maxWidth = "";
    if (menuFoodItemModal) {
      return maxWidth == "500px";
    } else if (subMenuModal) {
      return maxWidth == "700px";
    } else {
    }
  };

  return (
    <>
      {/* 
      <h3 className="card-title">Menu Management -  {selectedOutlet?.label} </h3>
      <br /> */}

      <div className="row">
        {/*  <div className="col-md-4">
          <Card>
            <Card.Header className="card-title">
              Menu List {""}
              <Button
                variant="success dark btn-sm"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  //  setSubMenuModal(false),
                  setMainMenuModal(true);
                }}
              >
                <i class="fas fa-plus">Menu </i>
              </Button>
              <br />
              <Button
                variant="success dark btn-sm"
                onClick={() => {
                  getMenuMasterListMasterApi();
                  // setMenuFoodItemModal(false),
                  setSubMenuModal(true);
                  // setMainMenuModal(true)
                }}
              >
                <i class="fas fa-plus">Sub-Menu</i>{" "}
              </Button>
            </Card.Header>
            <br />

            <Card.Body>
              <Tab.Container defaultActiveKey="#home">
                <Col lg="6" xl="6">                
                  <ListGroup className="mb-4" id="list-tab">
                    <ListGroup.Item action href="#home">
                      cocount idly
                    </ListGroup.Item>
                    <ListGroup.Item action href="#profile">
                      Paneer Idly
                    </ListGroup.Item>
                    <ListGroup.Item action href="#messages">
                      Masala Dosa
                    </ListGroup.Item>
                    <ListGroup.Item action href="#settings">
                      Ghee Dosa
                    </ListGroup.Item>
                  </ListGroup>
                </Col>
                <Col lg="6" xl="10">
                  <Tab.Content>
                    <Tab.Pane eventKey="#home">
                      <tbody>
                        <tr>
                          <td>Cocount idly</td>
                          <td>30</td>

                          <td>
                            <Badge variant="success light">Veg</Badge>
                          </td>

                          <td>
                            <i
                              onClick={itemtoggle}
                              style={{ fontSize: "large" }}
                              className="ti-pencil"
                            ></i>
                          </td>
                        </tr>
                      </tbody>
                    </Tab.Pane>
                    <Tab.Pane eventKey="#profile">
                      <tr>
                        <td>Paneer Idly</td>
                        <td>60</td>
                        <td>
                          <Badge variant="success light">Veg</Badge>
                        </td>
                        <td>
                          <i
                            onClick={itemtoggle}
                            style={{ fontSize: "large" }}
                            className="ti-pencil"
                          ></i>
                        </td>
                      </tr>
                    </Tab.Pane>
                    <Tab.Pane eventKey="#messages">
                      <tr>
                        <td>Masala Dosa</td>
                        <td>50</td>
                        <td>
                          <Badge variant="success light">Veg</Badge>
                        </td>
                        <td>
                          <i
                            onClick={itemtoggle}
                            style={{ fontSize: "large" }}
                            className="ti-pencil"
                          ></i>
                        </td>
                      </tr>
                    </Tab.Pane>
                    <Tab.Pane eventKey="#settings">
                      <tr>
                        <td>Ghee Dosa</td>
                        <td>90</td>
                        <td>
                          <Badge variant="success light">Veg</Badge>
                        </td>
                        <td>
                          <i
                            onClick={itemtoggle}
                            style={{ fontSize: "large" }}
                            className="ti-pencil"
                          ></i>
                        </td>
                      </tr>
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Tab.Container>
            </Card.Body>

            <br />
          </Card>
        </div> */}
        <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12">
          <Card>
            <Card.Header className="card-title">
              {/* <h4> Menu List </h4> */}

              <h3
                className="me-auto"
                style={{ fontFamily: "Roboto", color: "darkgreen" }}
              >
                Menu List
              </h3>

              {/* <input type="text" >  </input>
              <i class="fas fa-plus"> </i>
              <i class="fas fa-plus"></i> */}

              {/* <Button
                variant="success dark btn-sm"
                style={{ marginLeft: "493px", backgroundColor: "#4cb32b" }}
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  //  setSubMenuModal(false),
                  setMainMenuModal(true);
                }}
              >
                <i class="fas fa-plus">Add Menu </i>
              </Button> */}

              {/* <Button
                variant="success dark btn-sm"
                style={{ backgroundColor: "#4cb32b" }}
                onClick={() => {
                  getMenuMasterListMasterApi();
                  // setMenuFoodItemModal(false),
                  setSubMenuModal(true);
                  // setMainMenuModal(true)
                }}
              >
                <i class="fas fa-plus">Add Sub-Menu</i>{" "}
              </Button> */}

              <input
                type="text"
                placeholder="search menu item/tag"
                style={{
                  marginRight: "324px",
                  border: "2px solid #3abd4a",
                  borderRadius: "12px",
                  padding: "5px",
                }}
                onChange={(e) => {
                  console.log("onChange", e);
                  searchFilterMenuListMaster(e.target.value);
                }}
                // onkeypress={(e) => {
                //
                //   console.log("onkeypress", e)
                // }}
              />

              {/* <i class="fas fa-plus"> </i>
              <i class="fas fa-plus"></i> */}
              <div>
                <i
                  className="fa fa-download mb-2"
                  onClick={saveExcel}
                  style={{ marginRight: "13px", color: "green" }}
                ></i>
              </div>
              <Button
                className="me-2"
                variant="success dark btn-sm"
                style={{ backgroundColor: "#4cb32b" }}
                onClick={() => {
                  getoutletList();
                }}
                /*  onClick={() => {
                setMenulistitem({
                  itemDesc: "",
                  itemFoodImage: "",
                  itemId: "",
                  itemName: "",
                  itemPrice: "",
                  itemQuantity: "",
                  itemType: true,
                });
                getMenuMasterListMasterApi();
                setSelecteduomMaster({});
                setActiveStep(0);
                setErrors({});
                setMenuFoodItemModal(!menuFoodItemModal);
                setIsview(false);
                setIsedit(false);
              }} */
              >
                <i
                  class="fas fa-plus"
                  onClick={() => {
                    getoutletList();
                  }}
                >
                  Add Item{" "}
                </i>{" "}
              </Button>

              {/* <i
                          className="fa fa-download mt-4"
                          onClick={saveExcel}
                          // disabled={restarantvalue.value == ""}
                          style={{ marginRight: "13px", color: "green" }}
                        ></i> */}
              <Button
                className="me-2"
                variant="success dark btn-sm"
                // disabled={restarantvalue.value == ""}
                style={{
                  backgroundColor: "#1F3DB6",
                  borderRadius: "2px",
                  border: "0px solid",
                  height: "36px",
                  padding: "6px",
                }}
                onClick={() => {
                  getSubscriptionList();
                }}
              >
                <i
                  class="fas fa-plus"
                  onClick={() => {
                    getSubscriptionList();
                  }}
                >
                  Subscription{" "}
                </i>
              </Button>
            </Card.Header>
            <Card.Body className="scroll-tbl-fix-header">
              <Table responsive stripped>
                <thead>
                  <tr>
                    <th>
                      <strong>ITEM NAME</strong>
                    </th>
                    <th>
                      <strong>ITEM PRICE</strong>
                    </th>

                    <th>
                      <strong>ITEM TYPE</strong>
                    </th>

                    <th>
                      <strong>ITEM QTY</strong>
                    </th>

                    <th>
                      <strong>UOM</strong>
                    </th>

                    <th>
                      <strong>ITEM TAG</strong>
                    </th>

                    <th>
                      <strong>IMAGE</strong>
                    </th>

                    <th>
                      <strong>ITEM DETAIL</strong>
                    </th>

                    <th>
                      <strong>ACTIONS</strong>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {menufetchitem &&
                    menufetchitem.map((items) => {
                      return (
                        <>
                          <tr>
                            <td>{items.itemName}</td>
                            <td>{items.itemPrice}</td>
                            <td>
                              {items.itemType == "veg" ? (
                                <Badge variant="success light">
                                  {items.itemType}
                                </Badge>
                              ) : (
                                <Badge variant="warning light">
                                  {items.itemType}
                                </Badge>
                              )}
                            </td>
                            <td>{items.itemQuantity}</td>
                            <td>{items.uomName}</td>
                            {/* <td>{items.itemTag}</td> */}

                            <td>
                              {/* { items.itemTag  selected.map((items) => (                            
                <Badge key={items.itemTag} label={items.itemTag}  />
              ))} */}
                              <Badge variant="success dark">
                                {items.itemTag}
                              </Badge>
                            </td>

                            <td>
                              <img
                                src={items.itemImagePath}
                                onClick={() => {
                                  setOpenImagePopup(!openImagePopup);
                                  setTempModalPopupValue(items.itemImagePath);
                                }}
                                width="50%"
                                height="50%"
                                target="blank"
                                style={{ width: "30px" }}
                              ></img>
                            </td>
                            <td>{items.itemDesc}</td>

                            <td>
                              <i
                                onClick={() => {
                                  itemtoggle(items);
                                }}
                                style={{ fontSize: "large" }}
                                className="ti-pencil"
                              ></i>

                              <i
                                onClick={() => {
                                  deletetoggle(items);
                                  setDeletepopup(true);
                                }}
                                style={{
                                  fontSize: "large",
                                  paddingLeft: "15px",
                                }}
                                className="ti-trash"
                              ></i>
                            </td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>

                {/* {selectedFoodSubmenuItem &&
                    selectedFoodSubmenuItem.length <= 0 && (
                      <div>
                        <br />
                        No Data Found
                      </div>
                    )} */}
              </Table>
            </Card.Body>
          </Card>
        </div>
      </div>

      <Modal
        isOpen={
          mainMenuModal ||
          subMenuModal ||
          menuFoodItemModal ||
          foodItemTiming ||
          deletepopup
        }
        toggle={() => onClose()}
        style={{
          maxWidth:
            (menuFoodItemModal && "800px") ||
            (subMenuModal && "700px") ||
            (foodItemTiming && "1200px"),
        }}
        backdrop="static"
      >
        <ModalHeader>
          {
            (mainMenuModal && "Add Main Menu") ||
              (subMenuModal && "Add Sub Menu") ||
              (deletepopup && " Delete Item") ||
              (menuFoodItemModal &&
              (menulistitem?.status == undefined || menulistitem?.status == "")
                ? `Add Item `
                : `Update Item - ${menulistitem?.itemName} `)

            /* (openImagePopup && "View Food Image") */
          }
          {/* <br /> */}

          {/*  <i
            className="ti-close"
            onClick={() => {
              setMainMenuModal(false);
              setSubMenuModal(false);
              setMenuFoodItemModal(false);
              setOpenImagePopup(false);
              setErrors({});
            }}
            style={{
              paddingTop: "10px",
              color: "black",
              fontSize: "medium",
              paddingLeft: "620px",
            }}
          ></i> */}

          {/* {menuFoodItemModal &&
            <img
              src={menulistitem.itemImagePath}
              style={{ width: "50px", height: "50px", marginLeft: "29px" }}
             target="blank"
            ></img>
          } */}

          {foodItemTiming && (
            <>
              <br />
              <div className="row">
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <Select
                    // IsMulti={true}
                    options={dropdownMaster}
                    // options={outletRolelist.filter((item) => {
                    //   return item.label != "ADMIN";
                    // })}
                    // search
                    // value={dropdownMastervalue}
                    value={dropdownMastervalue}
                    name="stateCode"
                    placeholder="Choose"
                    onChange={(event) => dropdownHandling("type", event)}
                  />
                </div>

                {/* {dropdownMastervalue.value == "2" && */}
                <div className="col-sm-6 col-md-3 col-xl-3">
                  <Select
                    // IsMulti={true}
                    options={dropdownMasterDay}
                    // options={outletRolelist.filter((item) => {
                    //   return item.label != "ADMIN";
                    // })}
                    search
                    // isDisabled={dropdownMastervalue?.value != "2"}
                    // disabled={dropdownMastervalue?.value != "2"}
                    // value={staffvalue}
                    name="stateCode"
                    placeholder="Day"
                    // onChange={(event) =>
                    //   dropdownHandling("type", event)
                    // }
                  />
                </div>

                {/* } */}

                <div className="col-sm-6 col-md-3 col-xl-3">
                  {/* <Select
                    options={dropdownslotmaster}
                    search
                    name="stateCode"
                    placeholder="Slot"
                  /> */}
                  <Multiselect
                    options={dropdownslotmaster}
                    // selectedValues={selectedValueRegion}
                    // onSelect={this.handleRegion}
                    // onRemove={this.handleRemoveRegion}
                    showCheckbox={true}
                    closeOnSelect={false}
                    displayValue="label"
                  />
                </div>
                <div className="col-sm-6 col-md-3 col-xl-3">
                  <Button
                    variant="primary"
                    // style={{ marginLeft: "352px" }}
                    onClick={() => {
                      apiMasterCallOfmenuAvailablityListSaveUpdateDeleteMaster();
                      // setFoodItemTiming(!foodItemTiming);
                      // console.log("current", menuAvailablityListSaveUpdateDeleteMaster);
                    }}
                  >
                    Update Slot
                  </Button>
                </div>
              </div>

              {/* <label style={{ paddingLeft: "290px" }}>
                <input type="checkbox"
                  checked={checkeditem}
                  onChange={() => {
                    alldayallsotBoolean();
                  }}
                />
                All Day All Slot  {checkeditem}
              </label> */}

              {/* const [checkeditem, setCheckeditem] = useState(false); */}
            </>
          )}
        </ModalHeader>
        <ModalBody>
          {deletepopup && (
            <>
              <span>
                Are you sure want to delete item ?{" "}
                <strong>{menulistitem?.itemName}</strong>
              </span>
            </>
          )}

          {mainMenuModal && (
            <div className="row">
              <div className="col-sm-8 col-md-8 col-xl-8">
                <FormGroup>
                  <Label for="menu">
                    Main Menu Name
                    <span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="menu"
                    id="menu"
                    placeholder="Enter  Menu"
                    maxLength="40"
                    required
                    autoComplete="off"
                    onChange={(e) => {
                      //
                      setMenuSubmenuItems({
                        menuName: e.target.value,
                      });
                    }}
                  />
                </FormGroup>
              </div>
            </div>
          )}
          {subMenuModal && (
            <div className="row">
              <div className="col-sm-6 col-md-6 col-xl-5">
                <FormGroup>
                  <Label for="itemqty">
                    Menu Name<span class="text-danger">*</span>
                  </Label>
                  <Select
                    options={category}
                    search
                    name="stateCode"
                    placeholder="Choose Menu"
                    autoComplete="off"
                    value={outletvalue}
                    onChange={(event) => {
                      setOutletvalue({
                        label: event.label,
                        value: event.value,
                      });
                    }}
                  />
                </FormGroup>
              </div>
              <div className="col-sm-6 col-md-6 col-xl-5">
                <FormGroup>
                  <Label for="submenu">
                    Sub Menu
                    <span class="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="submenu"
                    id="submenu"
                    placeholder="Enter Sub Menu"
                    maxLength="40"
                    required
                    autoComplete="off"
                    onChange={(e) => {
                      //
                      setMenuSubmenuItems({
                        subMenuName: e.target.value,
                      });
                    }}
                  />
                </FormGroup>
              </div>
            </div>
          )}
          {menuFoodItemModal && (
            <>
              <FoodMenuForm
                menulistitem={menulistitem}
                additemSubmenuMaster={additemSubmenuMaster}
                onChangeCommonpopup={onChangeCommonpopup}
                category={category}
                uomlist={uomlist}
                uomcategory={uomcategory}
                selected={selected}
                selecteduomMaster={selecteduomMaster}
                errors={errors}
                isView={isView}
                onChangeCommonpopupsetOutletvalue={
                  onChangeCommonpopupsetOutletvalue
                }
                blockInvalidChar={blockInvalidChar}
                specialmenulist={specialmenulist}
                popularmenu={popularmenu}
                setSelectedSpecialMenu={setSelectedSpecialMenu}
                setSelectedPopularMenu={setSelectedPopularMenu}
              />
            </>
          )}

          {/*  {openImagePopup && (
            <>
              {tempModalPopupValue != "" ? (
                <>
                  {chkImgFile(tempModalPopupValue) ? (  
                    <>
                      <a href={tempModalPopupValue} download target="_blank">
                        Download Image
                      </a>

                      <br />
                      <ReactPanZoom image={tempModalPopupValue} alt="image" />
                    </>
                  ) : (
                    <iframe
                      src={tempModalPopupValue}
                      width="100%"
                      height="400px"
                    ></iframe>
                  )}
                </>
              ) : (
                <p>File Not Available</p>
              )}
            </>
          )} */}

          {foodItemTiming && (
            <div className="row">
              {menuAvailablityListSaveUpdateDeleteMaster &&
                menuAvailablityListSaveUpdateDeleteMaster.map((items) => {
                  return (
                    <Col xl="4">
                      <Card className="text-white  times-card">
                        <CardTitle className="text-white bg-secondary">
                          {items.dayName}
                          {/* <label style={{ paddingLeft: "150px" }}>
                          <input type="checkbox"
                            checked={checkeditem}
                          />{""}
                          Day Slot
                        </label> */}
                        </CardTitle>
                        <CardBody>
                          {items?.slotTime &&
                            items?.slotTime.map((data) => {
                              //
                              // console.log("data", data);
                              return (
                                <>
                                  {/* {data?.itemAvailablity === true && */}
                                  <div>
                                    <h4>
                                      {data.slotName} :
                                      <span className="badge badge-lg bg-green time-chip mr-2">
                                        {data.startTime} - {data.endTime}
                                      </span>
                                      {/* <label style={{ paddingLeft: "12px" }}>
                                    <input type="checkbox"
                                      checked={data?.itemAvailablity === true}
                                      onChange={() => { nestedLevelItemCheck(items?.dayId, data) }}
                                    />
                                  </label> */}
                                    </h4>
                                  </div>
                                  {/* } */}
                                </>
                              );
                            })}
                        </CardBody>
                      </Card>
                    </Col>
                  );
                })}
            </div>
          )}
        </ModalBody>

        <ModalFooter>
          {deletepopup && (
            <>
              <Button
                variant="success"
                onClick={() => {
                  deleteitem("Deletemenu");
                }}
              >
                Delete
              </Button>
              <Button
                variant="danger"
                onClick={() => {
                  setDeletepopup(false);
                }}
              >
                Cancel
              </Button>
            </>
          )}
          {mainMenuModal && (
            <>
              <Button
                variant="primary"
                // disabled={menuSubmenuItems?.menuName == ""}
                onClick={() => {
                  saveMenuSubmenu("Maninmenu");
                }}
              >
                Save
              </Button>

              <Button
                variant="danger light"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  //  setSubMenuModal(false),
                  // setMainMenuModal(false);

                  setMainMenuModal(false);
                  setSubMenuModal(false);
                  setMenuFoodItemModal(false);
                  setOpenImagePopup(false);
                }}
              >
                Close
              </Button>
            </>
          )}

          {subMenuModal && (
            <>
              <Button
                variant="primary"
                // disabled={menuSubmenuItems?.subMenuName == ""}
                onClick={() => {
                  saveMenuSubmenu("SubManinmenu");
                }}
              >
                Save
              </Button>
              <Button
                variant="danger light"
                onClick={() => {
                  // setMenuFoodItemModal(false),
                  // setSubMenuModal(false);
                  // setMainMenuModal(false)

                  setMainMenuModal(false);
                  setSubMenuModal(false);
                  setMenuFoodItemModal(false);
                  setOpenImagePopup(false);
                }}
              >
                Close
              </Button>
            </>
          )}

          {menuFoodItemModal && (
            <>
              {isView === false && isedit === false && (
                <Button
                  variant="primary"
                  disabled={
                    menulistitem.itemFoodImage == "" ||
                    (selected && selected.length == 0)
                  }
                  /* className={!formIsValid ? "btn-disabled" : "btn-primary"} */
                  onClick={() => {
                    submitFoodItemApi();
                  }}
                >
                  Submit
                </Button>
              )}
              {isView === true && isedit === false && (
                <Button
                  variant="contained"
                  // className={!formIsValid ? "btn-disabled" : "btn-primary"}
                  className={"btn-primary"}
                  onClick={() => {
                    submitFoodItemApi();
                  }}
                  // disabled={!formIsValid}
                >
                  Update
                </Button>
              )}

              <Button
                variant="secondary"
                onClick={() => {
                  setMainMenuModal(false);
                  setSubMenuModal(false);
                  setMenuFoodItemModal(false);
                  setOpenImagePopup(false);
                  setErrors({});
                  setIsview(false);
                  setIsedit(false);
                  setSelecteduomMaster({});
                  setSelected([]);
                }}
              >
                Cancel
              </Button>
            </>
          )}

          {foodItemTiming && (
            <>
              <Button
                variant="danger light"
                onClick={() => {
                  setFoodItemTiming(false);
                  setMainMenuModal(false);
                  setSubMenuModal(false);
                  setMenuFoodItemModal(false);
                  setOpenImagePopup(false);
                }}
              >
                Cancel
              </Button>
            </>
          )}
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={openImagePopup}
        toggle={() => CloseImage()}
        style={{ maxWidth: "800px" }}
        backdrop="static"
      >
        <ModalHeader>
          <>
            {tempModalPopupValue != "" ? (
              <>
                {chkImgFile(tempModalPopupValue) ? (
                  <>
                    <a href={tempModalPopupValue} download target="_blank">
                      Download Image
                    </a>
                    <i
                      className="ti-close"
                      onClick={CloseImage}
                      style={{
                        paddingTop: "10px",
                        paddingLeft: "599px",
                        color: "black",
                        fontSize: "medium",
                      }}
                    ></i>
                    <br />
                    <ReactPanZoom image={tempModalPopupValue} alt="image" />
                  </>
                ) : (
                  <iframe
                    src={tempModalPopupValue}
                    width="100%"
                    height="100px"
                  ></iframe>
                )}
              </>
            ) : (
              <p>File Not Available</p>
            )}
          </>
        </ModalHeader>
      </Modal>
      <Modal
        isOpen={togglemodal}
        toggle={() => onToggleClose()}
        size={"lg"}
        style={{ maxWidth: "800px" }}
        backdrop="static"
      >
        <ModalHeader onClick={onToggleClose}>
          Category / Sub Category Update
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-sm-6 col-md-4 col-xl-4">
              <FormGroup>
                <Label for="itemqty">Main Category</Label>
                <Select
                  options={menu}
                  search
                  placeholder="Choose Menu"
                  autoComplete="off"
                />
              </FormGroup>
            </div>
            <div className="col-sm-6 col-md-4 col-xl-4">
              <FormGroup>
                <Label for="itemqty">
                  Sub Category <span class="text-danger">*</span>
                </Label>
                <Select
                  options={submenu}
                  search
                  placeholder="Choose SubMenu"
                  autoComplete="off"
                />
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="me-2"
            variant="success"
            onClick={() => onToggleClose(false)}
          >
            Submit
          </Button>
          <Button variant="danger" onClick={() => onToggleClose(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default TMPFoodMenuManagment;
